module.exports = __webpack_public_path__ + "img/北京.963990de.png";